export const DEFAULT_PALETTE = {
  primary: {
    lighter: '#C8FAD6',
    light: '#5BE49B',
    main: '#00A76F',
    dark: '#007867',
    darker: '#004B50',
    contrastText: '#FFFFFF'
  },
  secondary: {
    lighter: '#EFD6FF',
    light: '#C684FF',
    main: '#8E33FF',
    dark: '#5119B7',
    darker: '#27097A',
    contrastText: '#FFFFFF'
  },
  info: {
    lighter: '#CAFDF5',
    light: '#61F3F3',
    main: '#00B8D9',
    dark: '#006C9C',
    darker: '#003768',
    contrastText: '#FFFFFF'
  },
  success: {
    lighter: '#D3FCD2',
    light: '#77ED8B',
    main: '#22C55E',
    dark: '#118D57',
    darker: '#065E49',
    contrastText: '#ffffff'
  },
  warning: {
    lighter: '#FFF5CC',
    light: '#FFD666',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: '#1C252E'
  },
  error: {
    lighter: '#FFE9D5',
    light: '#FFAC82',
    main: '#FF5630',
    dark: '#B71D18',
    darker: '#7A0916',
    contrastText: '#FFFFFF'
  },
  grey: {
    '50': '#FCFDFD',
    '100': '#F9FAFB',
    '200': '#F4F6F8',
    '300': '#DFE3E8',
    '400': '#C4CDD5',
    '500': '#919EAB',
    '600': '#637381',
    '700': '#454F5B',
    '800': '#1C252E',
    '900': '#141A21'
  },
  common: {
    black: '#000000',
    white: '#FFFFFF'
  }
}

// --------------------------------------------------------------------------------------------- //

export const CUSTOM_PALETTE = {
  primary: {
    lighter: '#C8FAD6',
    light: '#5BE49B',
    main: '#00A76F',
    dark: '#007867',
    darker: '#004B50',
    contrastText: '#FFFFFF'
  },
  secondary: {
    lighter: '#EFD6FF',
    light: '#C684FF',
    main: '#8E33FF',
    dark: '#5119B7',
    darker: '#27097A',
    contrastText: '#FFFFFF'
  },
  info: {
    lighter: '#CAFDF5',
    light: '#61F3F3',
    main: '#00B8D9',
    dark: '#006C9C',
    darker: '#003768',
    contrastText: '#FFFFFF'
  },
  success: {
    lighter: '#D3FCD2',
    light: '#77ED8B',
    main: '#22C55E',
    dark: '#118D57',
    darker: '#065E49',
    contrastText: '#ffffff'
  },
  warning: {
    lighter: '#FFF5CC',
    light: '#FFD666',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: '#1C252E'
  },
  error: {
    lighter: '#FFE9D5',
    light: '#FFAC82',
    main: '#FF5630',
    dark: '#B71D18',
    darker: '#7A0916',
    contrastText: '#FFFFFF'
  },
  grey: {
    '50': '#F7FAFC',
    '100': '#EDF2F7',
    '200': '#E2E8F0',
    '300': '#CBD5E0',
    '400': '#A0AEC0',
    '500': '#718096',
    '600': '#4A5568',
    '700': '#2D3748',
    '800': '#141A25',
    '900': '#10151E'
  },
  common: {
    black: '#000000',
    white: '#FFFFFF'
  }
}

// --------------------------------------------------------------------------------------------- //

const commonColors = {
  blue: {
    50: '#EBEFFE',
    100: '#B5C4FC',
    200: '#7F99FB',
    300: '#5F80FA',
    400: '#486FF9',
    500: '#3761F9',
    600: '#2D4EC9',
    700: '#243EA1',
    800: '#1C317E',
    900: '#15255F'
  },
  gray: {
    950: '#090B11',
    900: '#10151E',
    850: '#191d28',
    825: '#191e2a',
    815: '#1a1f2b',
    800: '#141A25',
    785: '#1A202C',
    750: '#212631',
    700: '#2D3748',
    600: '#4A5568',
    500: '#718096',
    400: '#A0AEC0',
    300: '#CBD5E0',
    200: '#E2E8F0',
    100: '#EDF2F7',
    50: '#F7FAFC'
  },
  green: {
    900: '#004F3A',
    800: '#00684D',
    700: '#008562',
    600: '#00A67B',
    500: '#00CD98',
    400: '#16D1A1',
    300: '#33D7AD',
    200: '#5CDFBD',
    100: '#A1ECD9',
    50: '#E6FAF5'
  },
  red: {
    50: '#FFF5F5',
    100: '#FFF8F8',
    200: '#FDE3E3',
    300: '#FAC1C0',
    400: '#F5918F',
    500: '#EF5350',
    600: '#DD4D4A',
    700: '#C74543',
    800: '#AE3C3B',
    900: '#923231'
  },
  darkTeal: {
    500: '#144241',
    300: '#3F6D6C'
  },
  darkNeutral: {
    950: '#101214',
    900: '#161A1D',
    800: '#1D2125',
    750: '#22272B',
    700: '#282E33',
    650: '#2C333A',
    600: '#38414A',
    550: '#454F59',
    500: '#596773',
    450: '#738496',
    400: '#8C9BAB',
    300: '#9FADBC',
    200: '#B6C2CF',
    100: '#C7D1DB',
    50: '#C7D1DB'
  },
  darkNeutralAlpha: {
    950: 'rgba(16, 18, 20, 0.80)',
    900: 'rgba(3,4,4,0.26)',
    800: 'rgba(188,214,240,0.04)',
    700: 'rgba(161,189,217,0.08)',
    600: 'rgba(200,225,249,0.1)',
    500: 'rgba(166,197,226,0.16)',
    400: 'rgba(195,222,254,0.2)',
    300: 'rgba(191,219,248,0.28)',
    200: 'rgba(155,180,202,0.5)'
  }
}

const GREY_MINIMALS = {
  '50': '#FCFDFD',
  '100': '#F9FAFB',
  '200': '#F4F6F8',
  '300': '#DFE3E8',
  '400': '#C4CDD5',
  '500': '#919EAB',
  '600': '#637381',
  '700': '#454F5B',
  '800': '#1C252E',
  '900': '#141A21'
}

const GREY_SHAPESHIFT = {
  '50': '#F7FAFC',
  '100': '#EDF2F7',
  '200': '#E2E8F0',
  '300': '#CBD5E0',
  '400': '#A0AEC0',
  '500': '#718096',
  '600': '#4A5568',
  '700': '#2D3748',
  '750': '#212631',
  '785': '#1A202C',
  '800': '#141A25',
  '815': '#1a1f2b',
  '825': '#191e2a',
  '850': '#191d28',
  '900': '#10151E',
  '950': '#090B11'
}
